<app-draggable-modal-wrapper>
    <h2
        mat-dialog-title
        modal-drag-handle
        class="!text-2xl !font-normal !text-primary-700 !mb-2"
    >
        {{ data.title }}
    </h2>
    <hr />
    <mat-dialog-content class="mat-typography">
        <ng-content></ng-content>

        @if (data.content) {
            <p
                class="text-base text-tertiary-900"
                [innerHtml]="data.content"
            ></p>
        }
    </mat-dialog-content>
    <mat-dialog-actions align="end" class="!p-5">
        @if (data.isShowCancel !== false) {
            <button
                type="button"
                mat-stroked-button
                (click)="onCancel()"
                color="primary"
                class="!border-primary-700"
                name="cancel"
            >
                {{ data.cancelTitle ?? 'Cancel' }}
            </button>
        }

        @if (data.primaryAction) {
            <button
                mat-raised-button
                type="button"
                (click)="onPrimaryAction()"
                [name]="data.primaryAction.name"
                cdkFocusInitial
                color="primary"
                [class]="data.primaryAction.classList"
            >
                {{ data.primaryAction.title }}
            </button>
        }

        @if (data.secondaryAction) {
            <button
                mat-raised-button
                type="button"
                (click)="onSecondaryAction()"
                [name]="data.secondaryAction.name"
                color="primary"
                [class]="data.secondaryAction.classList"
            >
                {{ data.secondaryAction.title }}
            </button>
        }
    </mat-dialog-actions>
</app-draggable-modal-wrapper>
